module.exports = __webpack_public_path__ + "img/findmykit-lifestyle-1.af74ab47.png";